<template>
  <gg-card>
    <gg-card-header>
      Set PHP Version per Domain
    </gg-card-header>
    <gg-card-text>
      <v-row>
        <v-col cols="12">
          <p class="mb-0">
            Select the domains that you wish to change from the table, then apply a PHP version from the list.
          </p>
        </v-col>
        <v-col cols="12" md="5" class="d-flex align-end">
          <gg-select
            v-model="selectedVersion"
            label="PHP Version"
            hide-details
            :items="phpVersions"
            :loading="loadingVersions"
          >
            <template #selection="{ item }">{{ formatPhpVer(item) }}</template>
            <template #item="{ item }">{{ formatPhpVer(item) }}</template>
          </gg-select>
          <gg-btn
            class="mb-1 ml-4"
            :disabled="!canApply"
            :loading="submitting"
            @click="applyPhpVersion"
          >
            Apply
          </gg-btn>
        </v-col>
        <v-col cols="12">
          <v-data-table
            v-model="selectedVhost"
            show-select
            item-key="vhost"
            sort-by="vhost"
            :headers="headers"
            :items="vhostVersions"
            :loading="loadingVhost">
            <template #item.version="{ item }">
              {{ formatPhpVer(item.version) }}
            </template>
            <template #item.php_fpm="{ item }">
              <v-icon color="primary" size="24">{{ item.php_fpm == 1 ? 'mdi-check-bold' : '' }}</v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </gg-card-text>
  </gg-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'PhpManagerList',
  data () {
    return {
      loadingVersions: false,
      selectedVersion: '',
      loadingVhost: false,
      submitting: false,
      selectedVhost: [],
      headers: [
        {
          text: 'Domain',
          value: 'vhost',
        },
        {
          text: 'PHP Version',
          value: 'version',
        },
        {
          text: 'PHP-FPM',
          value: 'php_fpm',
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
      phpVersions: 'hosting_php/phpVersions',
      vhostVersions: 'hosting_php/vhostVersions',
    }),
    canApply () {
      return this.selectedVhost.length > 0
    }
  },
  methods: {
    ...mapActions({
      getPhpVersions: 'hosting_php/getPhpVersions',
      getVhostVersions: 'hosting_php/getVhostVersions',
      cpanel_uapi: 'cpanel_uapi',
      reportError: 'reportError',
      reportSuccess: 'reportSuccess'
    }),
    async loadVersions () {
      this.loadingVersions = true
      try {
        await this.getPhpVersions()
        this.selectedVersion = this.phpVersions[0] ?? ''
      } catch (e) {
        this.reportError(e)
      } finally {
        this.loadingVersions = false
      }
    },
    async loadVhosts () {
      this.loadingVhost = true
      try {
        await this.getVhostVersions()
      } catch (e) {
        this.reportError(e)
      } finally {
        this.loadingVhost = false
      }
    },
    async applyPhpVersion () {
      this.submitting = true
      const vhost = this.selectedVhost.reduce((carry, { vhost }, index) => {
        carry[`vhost-${index + 1}`] = vhost
        return carry
      }, {})
      const data = {
        uapi_module: 'LangPHP',
        uapi_function: 'php_set_vhost_versions',
        version: this.selectedVersion,
        ...vhost
      }
      try {
        await this.cpanel_uapi(data)
        this.reportSuccess(`Successfully applied PHP version "${this.selectedVersion}" to the selected domain(s)`)
        this.selectedVhost = []
        this.loadVhosts()
      } catch (e) {
        this.reportError(e)
      } finally {
        this.submitting = false
      }
    },
    formatPhpVer (version) {
      let ver = version.split('-').slice(-1)[0].replace('php', '').split('')
      ver = ver.slice(0, ver.length - 1).join('') + '.' + ver.slice(-1)[0]
      return `PHP ${ver} (${version})`
    },
  },
  mounted () {
    this.loadVersions()
    this.loadVhosts()
  }
}
</script>
